import * as Yup from 'yup';

const TIPOS_DOCUMENTO = ['NOTA FISCAL', 'CUPOM FISCAL', 'RECIBO'];

export const schema = Yup.object().shape({
  formaPagamento: Yup.string().required('Selecione a forma de pagamento'),
  responsavelTipo: Yup.string().required('Selecione o responsável pelo gasto'),
  cliente: Yup.mixed().when('responsavelTipo', {
    is: (v) => v === 'paciente',
    then: (schemaV) => schemaV.required('Selecione o responsável (paciente)'),
    otherwise: (schemaV) => schemaV.nullable(true),
  }),
  descricao: Yup.string()
    .required('Informe o motivo do gasto')
    .max(40, 'Máximo de 40 caracteres'),
  valor: Yup.string().required('Informe o valor da compra'),
  dataCompra: Yup.string().required('Informe a data da compra'),
  localCompra: Yup.string()
    .required('Informe o local da compra')
    .max(40, 'Máximo de 40 caracteres'),
  autorizadoPor: Yup.string()
    .required('Informe quem autorizou')
    .max(20, 'Máximo de 20 caracteres'),
  tipoDocumento: Yup.mixed()
    .required('Selecione o tipo de documento')
    .test('tipoDocumento', 'Selecione o tipo de documento', (value) => {
      const v = value?.value ?? value;
      return v && TIPOS_DOCUMENTO.includes(v);
    }),
  numeroDocumento: Yup.string()
    .required('Informe o número do documento')
    .max(15, 'Máximo de 15 caracteres'),
  ultimosNumerosCartao: Yup.string()
    .max(6, 'Máximo de 6 caracteres')
    .matches(/^\d{0,6}$/, 'Use apenas números')
    .when('formaPagamento', {
      is: (v) => v !== 'reembolso',
      then: (schemaV) => schemaV.required('Informe os últimos números do cartão'),
      otherwise: (schemaV) => schemaV.nullable().transform(() => ''),
    }),
  hasExistingComprovante: Yup.boolean().nullable(true),
  isChangingComprovante: Yup.boolean().nullable(true),
  file: Yup.mixed().when(['hasExistingComprovante', 'isChangingComprovante'], {
    is: (hasExistingComprovante, isChangingComprovante) => !hasExistingComprovante || !!isChangingComprovante,
    then: (schemaV) => schemaV.required('Envie o comprovante'),
    otherwise: (schemaV) => schemaV.nullable(true),
  }),
});
